import { OPEN_RATE_COLUMN_ID } from './columns/constants';
import { isDraft } from '../../../campaign-utils';
export var shouldShowOpenRate = function (campaign) { return !isDraft(campaign); };
export var shouldShowCellData = function (cell) {
    var campaign = cell.row.original;
    if (cell.column.columnDef.id === OPEN_RATE_COLUMN_ID) {
        return shouldShowOpenRate(campaign);
    }
    return true;
};
